import { AIImproveWritingPromptName } from 'apis/ai';
import { builtInImprovements } from 'components/editorCopilotDropdown/components/improveReply/editorCopilotDropdownImproveReply.constants';

import { type CopilotOfferedImprovement } from './copilotActions.types';

export const noStyleGuideReason = 'No style guide created for this channel';

type ResolveImprovementsArgs = {
  /** Improvements that can never apply in this context; hidden entirely. */
  excluded?: AIImproveWritingPromptName[];
  hasStyleGuideForChannel?: boolean;
};

/**
 * The improvements a context offers. Permanently inapplicable ones are dropped;
 * ones that are merely unavailable right now stay listed with a reason.
 */
export const resolveImprovements = ({
  excluded,
  hasStyleGuideForChannel,
}: ResolveImprovementsArgs): CopilotOfferedImprovement[] =>
  builtInImprovements
    .filter((improvement) => !excluded?.includes(improvement.value))
    .map((improvement) => ({
      value: improvement.value,
      name: improvement.name,
      includeContext: improvement.includeContext,
      disabledReason:
        improvement.value === 'repeat-input' && !hasStyleGuideForChannel
          ? noStyleGuideReason
          : undefined,
    }));
